import { IIssuer } from '@bca-agreement/models/issuer';
import { IAgreement } from '@bca-shared/models/agreement';
import { IAction } from '@bca-store/models/action';

export enum AgreementActionTypes {
  FetchIssuers = '[Agreement] FetchIssuers',
  SetIssuers = '[Agreement] SetIssuers',
  IssuersLoading = '[Agreement] IssuersLoading',
  SelectAgreement = '[Agreement] SelectAgreement',
  FetchAgreementPreview = '[Agreement] FetchAgreementPreview',
  SetAgreementPreview = '[Agreement] SetAgreementPreview',
  AgreementPreviewLoading = '[Agreement] AgreementPreviewLoading'
}

export class AgreementPreviewLoading implements IAction {
  readonly type = AgreementActionTypes.AgreementPreviewLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export class SetAgreementPreview implements IAction {
  readonly type = AgreementActionTypes.SetAgreementPreview;
  constructor(
    public readonly payload: {
      agreementPreviewAsBase64: string;
    }
  ) {}
}

export class FetchAgreementPreview implements IAction {
  readonly type = AgreementActionTypes.FetchAgreementPreview;
}

export class SelectAgreement implements IAction {
  readonly type = AgreementActionTypes.SelectAgreement;
  constructor(public readonly payload: IAgreement) {}
}

export class FetchIssuers implements IAction {
  readonly type = AgreementActionTypes.FetchIssuers;
}

export class SetIssuers implements IAction {
  readonly type = AgreementActionTypes.SetIssuers;
  constructor(public readonly payload: IIssuer[]) {}
}

export class IssuersLoading implements IAction {
  readonly type = AgreementActionTypes.IssuersLoading;
  constructor(public readonly payload: { loading: boolean }) {}
}

export type Action =
  | FetchIssuers
  | SetIssuers
  | IssuersLoading
  | SelectAgreement
  | FetchAgreementPreview
  | SetAgreementPreview
  | AgreementPreviewLoading;
